import React, { FC } from "react";

import { Career } from "../../../../state";
import TextField from "../TextField";
import HopeScoreSelector from "../HopeScoreSelector";
import QuestionHeader from "../QuestionHeader";
import useFormItemEditor from "../../../../hooks/useFormItemEditor";
import { ReactComponent as IconCross } from "../../../../assets/images/Career/ChallengeSheet/icon_cross.svg";
import { ReactComponent as IconPlus } from "../../../../assets/images/Career/ChallengeSheet/icon_plus.svg";
import styles from "../ChallengeSheetsModal.module.scss";

type Props = {
  careers: Career[];
  setCareers: (careers: Career[]) => void;
};

const SheetCareers: FC<Props> = ({ careers, setCareers }) => {
  const createCareer = (set_no: number): Career => ({
    set_no,
    content: "",
    reason: "",
    score: 1,
  });

  const {
    updateItem: updateCareer,
    addItem: addCareer,
    removeItem: removeCareer,
  } = useFormItemEditor<Career>(careers, setCareers, createCareer);

  return (
    <div className={styles.content}>
      <QuestionHeader
        title={"Q3.自分の進路について考えてみましょう。"}
        note={
          "進路を選ぶ上で、大切にしたいことはどんなことだろう？\nやりたいことや学びたいこと、雰囲気や価値観などを入力してみましょう。\n※複数ある場合は項目を追加しましょう。"
        }
      />
      <div className={styles.form}>
        <div className={styles.formList}>
          {careers.map((career, index) => (
            <div key={career.set_no} className={styles.formItem}>
              {careers.length > 1 && (
                <button
                  className={styles.removeButton}
                  onClick={() => removeCareer(index)}
                >
                  <IconCross />
                </button>
              )}
              <div className={styles.fieldset}>
                <TextField
                  id={`content-${career.set_no}`}
                  label="進路を選ぶ上で大切にしたいこと、学びたいこと、やりたいこと"
                  placeholder="専門的になりすぎず、色々な分野の勉強ができること"
                  value={career.content}
                  onChange={e =>
                    updateCareer(index, { content: e.target.value })
                  }
                />
              </div>
              <div className={styles.fieldset}>
                <TextField
                  id={`reason-${career.set_no}`}
                  label="理由（任意）"
                  placeholder="まだやりたいことが決まっていないから"
                  value={career.reason ?? ""}
                  onChange={e =>
                    updateCareer(index, { reason: e.target.value })
                  }
                />
              </div>
              <div className={styles.fieldset}>
                <HopeScoreSelector
                  name={`score-${career.set_no}`}
                  value={career.score}
                  onChange={e =>
                    updateCareer(index, { score: Number(e.target.value) })
                  }
                />
              </div>
            </div>
          ))}
        </div>
        <button className={styles.itemAddButton} onClick={() => addCareer()}>
          <IconPlus />
          項目を追加する
        </button>
      </div>
    </div>
  );
};

export default SheetCareers;
